import { MenuItem } from '@src/common/components/Menu';
import { useToast } from '@src/common/hooks/useToast';
import { PutOnHoldOrderModal } from '@src/orders/components/orderActionsMenu/modal/PutOnHoldOrderModal';
import { RevertOrderFromOnHoldModal } from '@src/orders/components/orderActionsMenu/modal/RevertOrderFromOnHoldModal';
import { OrderStatus } from '@src/orders/domain/Order';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { OrderActions } from '@src/orders/domain/OrderList';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  order: OrderListing;
  onStatusChange: () => void;
};
export const PutOnHoldAction = ({ order, onStatusChange }: Props) => {
  const { t } = useTranslation();
  const { showSuccessToast, showErrorToast } = useToast();

  const [openToggleOnHoldModal, setToggleOnHoldModal] = useState(false);

  const handlePutOnHoldClick = () => {
    setToggleOnHoldModal(true);
  };

  return (
    order.canDo(OrderActions.TOGGLE_ON_HOLD) && (
      <>
        <MenuItem
          key={`${order.id}-put-on-hold`}
          onClick={handlePutOnHoldClick}
        >
          {order.status === OrderStatus.HOLD ? t('reactivate') : t('putOnHold')}
        </MenuItem>
        {order.status === OrderStatus.HOLD && (
          <RevertOrderFromOnHoldModal
            open={openToggleOnHoldModal}
            onClose={() => setToggleOnHoldModal(false)}
            onSuccess={() => {
              showSuccessToast(t('orderSummary.reactivateSuccess'));
              onStatusChange();
              setToggleOnHoldModal(false);
            }}
            onError={() => {
              showErrorToast(t('orderSummary.reactivateError'));
            }}
            order={order}
          />
        )}

        {order.status !== OrderStatus.HOLD && (
          <PutOnHoldOrderModal
            open={openToggleOnHoldModal}
            onClose={() => setToggleOnHoldModal(false)}
            onSuccess={() => {
              showSuccessToast(t('orderSummary.putOnHoldSuccess'));
              onStatusChange();
              setToggleOnHoldModal(false);
            }}
            onError={() => {
              showErrorToast(t('orderSummary.putOnHoldError'));
            }}
            order={order}
          />
        )}
      </>
    )
  );
};
